import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL?.trim();
const supabasePublishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY?.trim();

export const hasSupabaseConfig = Boolean(supabaseUrl && supabasePublishableKey);

export const supabase = hasSupabaseConfig
  ? createClient(supabaseUrl, supabasePublishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export async function checkSupabaseConnection({ signal } = {}) {
  if (!hasSupabaseConfig) {
    return {
      ok: false,
      code: 'missing_config',
      message: 'Supabase 환경 변수가 설정되지 않았습니다.',
    };
  }

  try {
    const response = await fetch(`${supabaseUrl}/auth/v1/settings`, {
      method: 'GET',
      headers: {
        apikey: supabasePublishableKey,
      },
      signal,
    });

    if (!response.ok) {
      return {
        ok: false,
        code: 'request_failed',
        message: `Supabase 연결 확인 실패 (${response.status})`,
      };
    }

    return {
      ok: true,
      code: 'connected',
      message: 'Supabase 연결됨',
    };
  } catch (error) {
    if (error?.name === 'AbortError') {
      throw error;
    }

    return {
      ok: false,
      code: 'network_error',
      message: 'Supabase 네트워크 연결을 확인할 수 없습니다.',
    };
  }
}
